<template>
  <v-container fluid class="px-0 py-0">
    <template v-if="treeCfg">
      <drawer-left :drawerWidth="250">
        <template v-slot:left>
          <tree :cfg="treeCfg" :defaultActiveFirst="treeCfg.defaultActiveFirst" @active="onTreeChange" />
        </template>
        <template v-slot:right>
          <survey-result v-if="survey" :survey="survey" :items="items" :node="cNode || survey"
            :logHash="cNode ? cNode.logHash || {} : gItemLogHash">
          </survey-result>
        </template>
      </drawer-left>
    </template>
    <survey-result v-else :survey="survey" :items="items" :node="cNode || survey"
      :logHash="cNode ? cNode.logHash || {} : gItemLogHash">
    </survey-result>
  </v-container>
</template>
<script>
import { DrawerLeft, Tree } from "javaee-fre";
const SurveyResult = () => import("./survey-result.vue");
export default {
  name: "survey-dash",
  props: {
    surveyId: Number,
  },
  components: {
    "survey-result": SurveyResult,
    Tree,
    "drawer-left": DrawerLeft,
  },
  data() {
    return {
      treeCfg: null,
      survey: null,
      cNode: null,
      items: [],
      gItemLogHash: {},
    };
  },
  methods: {
    init() {
      let self = this,
        sid = self.$route.params._sid || self.surveyId;
      if (!sid) {
        return;
      }
      self.$axios.get(`/home/admin/c/survey/stats/${sid}`).then((r) => {
        let s = r.data.message,
          items = r.data.items,
          org = r.data.org,
          tHash = r.data.tHash,
          rHash = r.data.rHash,
          oHash = r.data.oHash,
          accCounts = r.data.accCounts,
          tree = null;

        //构建tree
        if (s.type == 1) {
          //从租户开始构建数据
          if (tHash && Object.keys(tHash).length > 0) {
            tree = [];
            for (let k in tHash) {
              let t = tHash[k];
              t._type = 1;
              tree.push(t);
            }
            if (oHash && Object.keys(oHash).length > 0) {
              for (let k in oHash) {
                let o = oHash[k];
                o._type = 1;
                if (o.parentId) {
                  let po = oHash[o.parentId];
                  if (po.chidren) {
                    po.push(o);
                  } else {
                    po.children = [o];
                  }
                } else {
                  let tmp = tHash[o.tenantId];
                  tmp._type = 1;
                  if (tmp.children) {
                    tmp.children.push(o);
                  } else {
                    tmp.children = [o];
                  }
                }
              }
            }
          }
        } else if (s.type == 2) {
          //填充机构
          if (oHash && Object.keys(oHash).length > 1) {
            tree = [];
            for (let k in oHash) {
              let o = oHash[k];
              o._type = 1;
              if (o.parentId == 0 || o.parentId == s.orgId) {
                tree.push(o);
              } else {
                let po = oHash[o.parentId];
                if (po.children) {
                  po.children.push(o);
                } else {
                  po.children = [o];
                }
              }
            }
          }
        } else if (s.type == 3) {
          //填充行政区划
          if (rHash != null && Object.keys(rHash).length > 0) {
            tree = [];
            for (let k in rHash) {
              let tmp = rHash[k];
              tmp._type = 2;
              if (tmp.pid == "0" || tmp.pid == s.region) {
                tree.push(tmp);
              } else {
                let pt = rHash[tmp.pid];
                if (pt) {
                  if (!pt.children) {
                    pt.children = [];
                  }
                  pt.children.push(tmp);
                }
              }
            }

            if (oHash && Object.keys(oHash).length > 0) {
              for (let k in oHash) {
                let o = oHash[k];
                o._type = 1;
                if (!o.region || o.type != 1) {
                  continue;
                }
                let region = rHash[o.region];
                if (!region) {
                  continue;
                }
                if (region.children) {
                  region.children.push(o);
                } else {
                  region.children = [o];
                }
              }
            }
          }
        }

        if (org) {
          s.etotalStuCount = org.etotalStuCount;
        }
        //遍历itemLog填充树的参与人数
        if (r.data.logs) {
          for (let l of r.data.logs) {
            let off = s.type == 3 ? 1 : 0,
              //tid = l[off],
              oid = l[off + 1],
              c = l[off + 2];
            /*
              if (tHash && tHash[tid]) {
                tHash[tid].joinCount = (tHash[tid].joinCount || 0) + c;
              }
              */
            if (oHash && oHash[oid]) {
              oHash[oid].joinCount = (oHash[oid].joinCount || 0) + c;
            }

            /*if (off == 1 && rHash && rHash[l[0]]) {
                rHash[l[0]].joinCount = (rHash[l[0]].joinCount || 0) + c;
              }
              */
          }
        }

        //遍历itemLogs
        if (r.data.itemLogs) {
          let gItemLogHash = {};
          for (let l of r.data.itemLogs) {
            let off = s.type == 3 ? 1 : 0,
              oid = l[off + 1],
              itemId = l[off + 2],
              itemLog = [0, 0, 0, 0, 0, 0];
            for (let i = 0; i < 7; i++) {
              itemLog[i] = l[off + 3 + i] || 0;
            }
            /*
              if (tHash && tHash[tid]) {
                let ilHash = tHash[tid].logHash || {};
                if (ilHash[itemId]) {
                  for (let i = 0; i < 7; i++) {
                    ilHash[itemId][i] = ilHash[itemId][i] + itemLog[i];
                  }
                } else {
                  ilHash[itemId] = itemLog;
                }
                tHash[tid].logHash = ilHash;
              }
              */
            if (oHash && oHash[oid]) {
              let ilHash = oHash[oid].logHash || {};
              if (ilHash[itemId]) {
                for (let i = 0; i < 7; i++) {
                  ilHash[itemId][i] = ilHash[itemId][i] + itemLog[i];
                }
              } else {
                ilHash[itemId] = itemLog;
              }
              oHash[oid].logHash = ilHash;
            }
            /*
              if (off == 1 && rHash && rHash[l[0]]) {
                let ilHash = rHash[l[0]].logHash || {};
                if (ilHash[itemId]) {
                  for (let i = 0; i < 7; i++) {
                    ilHash[itemId][i] = ilHash[itemId][i] + itemLog[i];
                  }
                } else {
                  ilHash[itemId] = itemLog;
                }
                rHash[l[0]].logHash = ilHash;
              }
              */

            let hash = gItemLogHash[itemId] || [0, 0, 0, 0, 0, 0];
            for (let i = 0; i < 7; i++) {
              hash[i] = hash[i] + itemLog[i];
            }
            gItemLogHash[itemId] = hash;
          }
          self.gItemLogHash = gItemLogHash;
        }
        if (tree) {
          if (s.type == 3) {
            //如果是监管部门，填充各区域的应参与人员信息
            let c = 0;
            for (let a of accCounts) {
              let //rc = a[0],
                oid = a[1],
                ac = a[2];
              c += ac;
              /*
              if (rc) {
                let region = rHash[rc];
                if (region) {
                  region.etotalStuCount = (region.etotalStuCount || 0) + ac;
                }
              }
              */
              if (oid) {
                let o = rHash[oid];
                if (o) {
                  o.etotalStuCount = (o.etotalStuCount || 0) + ac;
                }
              }
            }
            s.etotalStuCount = c;
          }
          //在填充一下树中上级机构数据的汇总问题
          self.fillTree(tree);

          self.treeCfg = {
            defaultActiveFirst: false,
            items: tree,
            label(i) {
              return `${i.name}(${i.joinCount || 0}/${i.etotalStuCount || 0})`;
            },
          };
        } else {
          self.treeCfg = null;
        }
        self.items = items;
        self.survey = s;
      });
    },
    onTreeChange(n) {
      this.cNode = n;
    },
    fillTree(d) {
      let self = this;
      if (!d || d.length == 0) {
        return;
      }
      for (let i of d) {
        if (i.children && i.children.length > 0) {
          self.fillTree(i.children);
          for (let c of i.children) {
            if (i._type == 2) {
              i.etotalStuCount =
                (i.etotalStuCount || 0) + (c.etotalStuCount || 0);
            }
            i.joinCount = (i.joinCount || 0) + (c.joinCount || 0);
            if (c.logHash) {
              let hash = i.logHash || {};
              for (let k in c.logHash) {
                let arr1 = hash[k] || [0, 0, 0, 0, 0, 0],
                  arr2 = c.logHash[k] || [0, 0, 0, 0, 0, 0];
                for (let i = 0; i < 7; i++) {
                  arr1[i] = arr1[i] + arr2[i];
                }
                hash[k] = arr1;
              }
              i.logHash = hash;
            }
          }
        }
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>

</style>